<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">settings</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="openProfilConnexion(data.idProfilConnexion)">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.voyages.travelhub.profilConnexion.code'"></strong>
                <span>{{ data.code }}</span>
            </li>
            <li>
                <strong [translate]="'admin.voyages.travelhub.profilConnexion.online'"></strong>
                <span>{{ (data.online ? 'global.oui' : 'global.non') | translate }}</span>
            </li>
            <li>
                <strong [translate]="'admin.voyages.travelhub.profilConnexion.offline'"></strong>
                <span>{{ (data.offline ? 'global.oui' : 'global.non') | translate }}</span>
            </li>
            <li>
                <strong [translate]="'admin.voyages.travelhub.profilConnexion.interne'"></strong>
                <span>{{ (data.interne ? 'global.oui' : 'global.non') | translate }}</span>
            </li>
            <li>
                <strong [translate]="'admin.voyages.travelhub.profilConnexion.actif'"></strong>
                <span>{{ (data.actif ? 'global.oui' : 'global.non') | translate }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button [matMenuTriggerFor]="listeActions">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #listeActions="matMenu">
            <button mat-menu-item (click)="deleteProfilConnexion(data.idProfilConnexion)" translate="global.actions.supprimer"></button>
            <button mat-menu-item (click)="copyProfilConnexion(data.idProfilConnexion)" translate="global.actions.dupliquer"></button>
        </mat-menu>
    </div>
</div>
